import { useCacheLocal } from "@/hooks/useCacheLocal";
import { TApiSortsReq } from "@/types/api";
import { createContext, ReactNode, useContext, useState } from "react";

type TCompanyFilterCache = {
  page?: number | null;
  tab?: string | null;
  sorts?: TApiSortsReq[];
  keyword?: string | null;
};

type CompanyFilterCacheContextType = {
  companyFilterCache: TCompanyFilterCache;
  setCompanyFilterCache: (newFilter: TCompanyFilterCache) => void;
};

const CompanyFilterCacheContext = createContext<CompanyFilterCacheContextType | undefined>(undefined);

export const CompanyFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("company-filter");

  const [companyFilterCache, setCompanyFilter] = useState<TCompanyFilterCache>({
    ...getJSON(),
  });

  const setCompanyFilterCache = (newFilter: TCompanyFilterCache) => {
    setJSON(newFilter);
    setCompanyFilter(newFilter);
  };

  return <CompanyFilterCacheContext.Provider value={{ companyFilterCache, setCompanyFilterCache }}>{children}</CompanyFilterCacheContext.Provider>;
};

export const useCompanyFilterCache = (): CompanyFilterCacheContextType => {
  const context = useContext(CompanyFilterCacheContext);
  if (!context) {
    throw new Error("useCompanyFilter must be used within CompanyFilterProvider");
  }
  return context;
};
